import produce from 'utils/produce';
import { getSuitablePage, isPhotoPlaceholder, isTextPlaceholder } from 'editor-utils/template';
import { generatePage } from './utils';

/**
 * Generate Yearbook from Instagram Photos.
 * @param {object} template
 * @param {object} coverPhoto
 * @param {Array} photos
 * @param {string} handle
 * @returns {{ data: { pages: Array, photos: Array }}}
 */
const generateYearBookData = async (template, coverPhoto, photos, handle) => {
  const [cover] = [coverPhoto]
    .map(photo => ({
      photo,
      page: generatePage(getSuitablePage(template.cover, photo)),
    }))
    .map(({ page, photo }) => {
      return produce(page, draft => {
        const photoPlaceholderIndex = page.placeholders.findIndex(isPhotoPlaceholder);
        if (photoPlaceholderIndex >= 0) {
          draft.placeholders[photoPlaceholderIndex].data = {
            photo_key: photo.key,
            x: 0.5,
            y: 0.5,
            scale: 1,
            orientation: 0,
          };
        }

        const textPlaceholderIndex = page.placeholders.findIndex(isTextPlaceholder);
        if (textPlaceholderIndex >= 0) {
          draft.placeholders[textPlaceholderIndex].data = {
            value: handle,
          };
        }
      });
    });

  const pages = photos
    .map(photo => ({
      photo,
      page: generatePage(getSuitablePage(template.pages, photo)),
    }))
    .map(({ page, photo }) => {
      return produce(page, draft => {
        const photoPlaceholderIndex = page.placeholders.findIndex(isPhotoPlaceholder);
        if (photoPlaceholderIndex >= 0) {
          draft.placeholders[photoPlaceholderIndex].data = {
            photo_key: photo.key,
            x: 0.5,
            y: 0.5,
            scale: 1,
            orientation: 0,
          };
        }
      });
    });

  return {
    data: {
      pages: [
        cover,
        generatePage({ id: 'inside-welcome' }),
        generatePage({ id: 'inside-blank' }),
        ...pages,
        generatePage({ id: 'inside-end' }),
      ],
      photos: [coverPhoto, ...photos],
    },
  };
};

export default generateYearBookData;
